import axios from 'axios';
import { variables } from "../Variables";

export const sendCalendarCreateApiErrorEmail = async (language = "en-GB", eventDetail) => {

    const translations = {
        "en-GB": {
            subject: "Calendar Event Creation Failed - Client ID:",
            greeting: "Dear Team,",
            intro1: "An issue occurred while creating a calendar event using the WHISE /calendars/create API.",
            intro2: "The system was unable to successfully create the event, and manual attention may be required.",
            errorDetails: "Error Details",
            clientId: "Client ID:",
            failureReason: "Reason of Failure:",
            eventDetails: "Event Details:",
            footer1: "Please review the above details and take the necessary action to resolve the issue.",
            footer2: "If the problem persists, kindly investigate the API response and system logs for further insights.",
            regards: "Regards,",
            system: "Smart Calendar System"
        },
        "fr-BE": {
            subject: "Échec de la création d’un événement calendrier - ID Client :",
            greeting: "Bonjour équipe,",
            intro1: "Un problème est survenu lors de la création d’un événement de calendrier via l’API WHISE /calendars/create.",
            intro2: "Le système n’a pas pu créer l’événement avec succès et une intervention manuelle pourrait être nécessaire.",
            errorDetails: "Détails de l’erreur",
            clientId: "ID du client :",
            failureReason: "Raison de l’échec :",
            eventDetails: "Détails de l’événement :",
            footer1: "Veuillez examiner les détails ci-dessus et prendre les mesures nécessaires pour résoudre le problème.",
            footer2: "Si le problème persiste, veuillez analyser la réponse de l’API ainsi que les journaux du système pour plus d’informations.",
            regards: "Cordialement,",
            system: "Système de calendrier intelligent"
        },
        "nl-BE": {
            subject: "Aanmaken van agenda-evenement mislukt - Klant-ID:",
            greeting: "Beste team,",
            intro1: "Er is een probleem opgetreden bij het aanmaken van een agenda-evenement via de WHISE /calendars/create API.",
            intro2: "Het systeem kon het evenement niet succesvol aanmaken en handmatige tussenkomst kan nodig zijn.",
            errorDetails: "Foutdetails",
            clientId: "Klant-ID:",
            failureReason: "Reden van mislukking:",
            eventDetails: "Details van het evenement:",
            footer1: "Gelieve de bovenstaande details te controleren en de nodige acties te ondernemen om het probleem op te lossen.",
            footer2: "Als het probleem aanhoudt, gelieve de API-respons en systeemlogs te onderzoeken voor verdere inzichten.",
            regards: "Met vriendelijke groeten,",
            system: "Slim kalendersysteem"
        }
    };

    const t = translations[language] || translations["en-GB"];

    const jsonconfig = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    };

    let html = "";

    html += "<table width='600' style='border:1px solid gray;border-radius:16px;margin:auto;font-family:Roboto;'>";

    html += "<tr><td style='text-align:center;padding:30px 0 40px'>";
    html += `<img src='${variables.AgentSiteURL + "assets/logo-placeholder.png"}' width='200' style='display:block;margin:auto'/>`;
    html += "</td></tr>";

    // Greeting
    html += `<tr><td style='padding:30px 30px 10px;'><strong>${t.greeting}</strong></td></tr>`;

    // Intro
    html += `<tr><td style='padding:10px 30px;color:#6B7280;font-size:13px;line-height:1.6;'>${t.intro1}<br/><br/>${t.intro2}</td></tr>`;

    // Card
    html += "<tr><td style='padding:20px;'>";
    html += "<table width='100%' style='border:1px solid #E5E7EB;border-radius:12px;'>";

    html += `<tr><td style='padding:16px 20px;font-size:11px;font-weight:bold;'>${t.errorDetails}</td></tr>`;
    html += "<tr><td style='padding:0 20px;'><hr/></td></tr>";

    html += `<tr><td style='padding:12px 20px;'><strong>${t.clientId}</strong> ${eventDetail.clientId}</td></tr>`;
    html += `<tr><td style='padding:12px 20px;'><strong>${t.failureReason}</strong><br/>${eventDetail.reason}</td></tr>`;
    html += `<tr><td style='padding:12px 20px;'><strong>${t.eventDetails}</strong><pre style='background:#F9FAFB;padding:10px;'>${JSON.stringify(eventDetail.eventDetail)}</pre></td ></tr >`;

    html += "</table></td></tr>";

    // Footer
    html += `<tr><td style='padding:10px 30px;color:#6B7280;font-size:13px;'>${t.footer1}<br/><br/>${t.footer2}</td></tr>`;

    // Regards
    html += `<tr><td style='padding:0 30px 30px;'>${t.regards}<br/>${t.system}</td></tr>`;

    html += "</table>";

    let objEmail = {
        emailTo: "abdulsaboor5059@gmail.com",
        body: html,
        subject: `${t.subject} ${eventDetail.clientId}`,
        emailType: "agent"
    };

    const url = variables.API_URL + `Email/SendEmail?`;

    axios.post(url, JSON.stringify(objEmail), jsonconfig)
        .catch(err => console.error("Email error:", err));
};